import { IconButtonSizeType, IconButtonVariantType, } from '../../../../../../components/iconButton/types/iconButton';
import { IconButtonStateType } from '../../../../../../components/iconButton/types/state';
import { commonStyles, largeContainerCommonStyles, largeIconCommonStyles, mediumContainerCommonStyles, mediumIconCommonStyles, smallContainerCommonStyles, smallIconCommonStyles, } from '../commonStyles';
export const getSecondaryMainSectionStyles = (FOUNDATIONS) => {
    return {
        [IconButtonVariantType.SECONDARY_MAIN_SECTION]: {
            [IconButtonSizeType.SMALL]: {
                [IconButtonStateType.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...smallContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...smallIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_125,
                    },
                },
                [IconButtonStateType.HOVER]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...smallContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...smallIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_125,
                    },
                },
                [IconButtonStateType.PRESSED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...smallContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...smallIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_exception_accent_pressed_secondary_icon_50,
                    },
                },
                [IconButtonStateType.DISABLED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...smallContainerCommonStyles(FOUNDATIONS),
                        cursor: 'default',
                    },
                    icon: {
                        ...smallIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
            },
            [IconButtonSizeType.MEDIUM]: {
                [IconButtonStateType.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...mediumContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...mediumIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                    },
                },
                [IconButtonStateType.HOVER]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...mediumContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...mediumIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                    },
                },
                [IconButtonStateType.PRESSED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...mediumContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...mediumIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_pressed_secondary_icon_250,
                    },
                },
                [IconButtonStateType.DISABLED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...mediumContainerCommonStyles(FOUNDATIONS),
                        cursor: 'default',
                    },
                    icon: {
                        ...mediumIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
            },
            [IconButtonSizeType.LARGE]: {
                [IconButtonStateType.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...largeContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...largeIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                    },
                },
                [IconButtonStateType.HOVER]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...largeContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...largeIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                    },
                },
                [IconButtonStateType.PRESSED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...largeContainerCommonStyles(FOUNDATIONS),
                    },
                    icon: {
                        ...largeIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_pressed_secondary_icon_250,
                    },
                },
                [IconButtonStateType.DISABLED]: {
                    ...commonStyles(FOUNDATIONS),
                    container: {
                        ...largeContainerCommonStyles(FOUNDATIONS),
                        cursor: 'default',
                    },
                    icon: {
                        ...largeIconCommonStyles(FOUNDATIONS),
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=secondaryMainSection.js.map